module.exports = __webpack_public_path__ + "img/product6.4be547ce.png";